/* Golden Hour Bazaar: progressive navigation preserves the existing audio DOM.
   Only read-only browsing routes are enhanced; commerce actions use Shopify normally. */
(function(){
 'use strict';
 const safePath=p=>p==='/'||(/^\/(pages|blogs|collections)(\/|$)/.test(p)&&!/^\/collections\/all$/.test(p));
 const blocked=/\/(cart|checkout|checkouts|account|apps|tools|password)(\/|$)/;
 const goUrl=(u)=>u.origin===location.origin&&safePath(u.pathname)&&!blocked.test(u.pathname)&&!u.searchParams.has('view');
 let busy=false;
 const main=()=>document.getElementById('MainContent');
 function replaceHead(doc){
  document.title=doc.title||document.title;
  for(const sel of ['link[rel="canonical"]','meta[name="description"]','meta[property="og:title"]','meta[property="og:description"]']){
   const incoming=doc.head.querySelector(sel),current=document.head.querySelector(sel);
   if(incoming&&current)current.replaceWith(incoming.cloneNode(true));
  }
 }
 async function navigate(target,push){
  if(busy)return false;
  busy=true;
  const current=main();
  if(current)current.setAttribute('aria-busy','true');
  try{
   const res=await fetch(target.href,{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'},redirect:'follow'});
   if(!res.ok||new URL(res.url).origin!==location.origin)throw Error('Unsafe response');
   const doc=new DOMParser().parseFromString(await res.text(),'text/html');
   const next=doc.getElementById('MainContent');
   if(!next)throw Error('Missing main content');
   main().replaceWith(document.importNode(next,true));
   // Reinitialize entrance animations after swapping sections: hidden product cards must become visible.
   main()?.querySelectorAll('[data-reveal]').forEach(el=>el.classList.add('is-revealed'));
   main()?.querySelectorAll('img[loading="lazy"]').forEach(img=>{if(img.complete&&img.naturalWidth===0)img.loading='eager';});
   replaceHead(doc);
   document.body.className=doc.body.className;
   document.body.dataset.bazaarRoom=doc.body.dataset.bazaarRoom||'';
   if(push)history.pushState({goldenBazaar:true},'',target.href);
   window.scrollTo({top:0,behavior:'instant'});
   // Shopify search/filter controls remain functional through plain GET navigation.
   const sort=main()?.querySelector('[data-sort-select]');
   sort?.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',sort.value);location.assign(u.href)});
   main()?.querySelectorAll('script').forEach(old=>{
    if(old.type&&old.type!=='text/javascript'&&old.type!=='module')return;
    const newScript=document.createElement('script');
    for(const attr of old.attributes)newScript.setAttribute(attr.name,attr.value);
    newScript.textContent=old.textContent;
    old.replaceWith(newScript);
   });
   main()?.focus({preventScroll:true});
   window.dispatchEvent(new CustomEvent('bazaar:page-loaded',{detail:{url:target.href}}));
   return true;
  }catch(err){return false}
  finally{busy=false;main()?.removeAttribute('aria-busy')}
 }
 // Capture before the theme's document-level transition handler.
 window.addEventListener('click',async ev=>{
  if(ev.defaultPrevented||ev.button!==0||ev.metaKey||ev.ctrlKey||ev.altKey||ev.shiftKey)return;
  const a=ev.target.closest?.('a[href]');
  if(!a||a.hasAttribute('download')||a.target&&a.target!=='_self'||a.closest('[data-bazaar-room-dialog]')||a.dataset.bazaarCommand)return;
  const u=new URL(a.href,location.href);
  if(!goUrl(u)||!goUrl(new URL(location.href))||u.href===location.href)return;
  ev.preventDefault();ev.stopImmediatePropagation();
  const success=await navigate(u,true);
  if(!success)location.assign(u.href);
 },true);
 window.addEventListener('popstate',async()=>{
  const u=new URL(location.href);
  if(!goUrl(u))return;
  const success=await navigate(u,false);
  if(!success)location.reload();
 });
})();
